/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { CoursePrice } from './CoursePrice';
const CoursePriceWithRefundDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['isRepurchase', codecBoolean, 'is_repurchase'],
]), CoursePrice);
export class CoursePriceWithRefundData extends CoursePrice {
    static decode(input) {
        return CoursePriceWithRefundDataParser.decode(input).map(res => new CoursePriceWithRefundData(res));
    }
    static unsafeDecode(input) {
        return CoursePriceWithRefundData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CoursePriceWithRefundDataParser.encode(data);
    }
    static schema() {
        return CoursePriceWithRefundDataParser.schema();
    }
}
